import { useEffect } from "react";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { setBasicInfo } from "../../../config/redux/clients/panel/clientPanelActions";
import { getCompany } from "../../../connectors/clients/connectors";

export const useBasicInfo = () => {
  const dispatch = useDispatch();
  const { selectedClients, addNewClient} = useSelector(
    (state: RootStateOrAny) => state.clients
  );

  const {clientPanelOpen, refetch}  = useSelector(
    (state: RootStateOrAny) => state.clientPanel
  );

  useEffect(() => {
    if(clientPanelOpen){
      setCompanyData();
    }
  }, [clientPanelOpen, addNewClient, selectedClients[0], refetch]);

  const setCompanyData = async () => {
      const res = await getCompany(selectedClients[0]);
    dispatch(setBasicInfo(res.data.data));
  };
};
